<template>
    <div>
        <div v-if="loaded">
            <app-nav></app-nav>
            <div id="certification-banner" class="is-hidden-mobile hero is-blue-dark py-3" v-if="doctor && ! doctor.isCertified">
                <div class="container">
                    <div class="has-text-centered has-text-weight-semibold is-size-6">
                        <p class="has-icon">
                            <b-icon icon="alert"></b-icon>
                            {{ $t('doctor_not_certified_warning') }}
                        </p>
                    </div>
                </div>
            </div>
            <main class="is-hidden-mobile mb-7" style="position: relative;">
                <router-view></router-view>
                <div class="notifications-wrapper" v-if="notifications.length">
                    <div class="notification clickable" v-for="notification in notifications" :key="notification.id" :class="notification.type" @click.prevent="showEmergency(notification.appointment)">
                        <button type="button" class="delete" @click.stop="disableNotification(notification)"></button>
                        <div class="media">
                            <div class="media-content" v-html="notification.content"></div>
                        </div>
                    </div>
                </div>
                <emergency-modal
                    v-if="Object.keys(currentEmergency).length > 0"
                    :active="showEmergencyModal"
                    @close="closeEmergencyModal()"
                    :emergency="currentEmergency"
                    :availability="currentAvailability">
                </emergency-modal>
            </main>
            <main class="is-hidden-tablet">
                <div class="has-text-centered has-text-weight-semibold is-size-6 mt-8 mx-4">
                    <p>{{ $t('app_message_on_mobile') }}</p>
                    <img src="/static/img/tood.png" alt="Tooddoc Mascot" class="mt-8" style="width: 90px;">
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app'
import moment from 'moment'
import helpers from '@/mixins/helpers'
import { db } from '@/firebase'

import doctorRepository from '@/data/DoctorRepository'
import doctorOfficeRepository from '@/data/DoctorOfficeRepository'
import emergencyRepository from '@/data/EmergencyRepository'
import timeSlotRepository from '@/data/TimeSlotRepository'

import AppNav from '@/components/Doctor/AppNav.vue'
import EmergencyModal from '@/components/Doctor/EmergencyModal.vue'

export default {
    name: 'doctor-app',

    components: { AppNav, EmergencyModal },

    mixins: [helpers],

    data() {
        return {
            loaded: false,
            showEmergencyModal: false,
            currentEmergency: {},
            currentAvailability: {}
        }
    },

    created () {
        this.setLoaded(false)
        this.setLoading(true)

        this.setListenAppointments(false)

        // Load doctor dependencies
        this.loadOffices()
        this.listenForAppointments()
    },

    methods: {
        loadOffices() {
            doctorOfficeRepository.load(this.userId, (offices) => {
                this.setOffices(offices)

                this.setLoaded(true)
                this.setLoading(false)
            }, (error) => {
                this.alertError(error.message)

                this.setLoaded(true)
                this.setLoading(false)
            })
        },

        listenForAppointments() {
            db.collection('appointments')
                .where('doctorId', '==', this.userId)
                .onSnapshot((snapshot) => {
                    if (! this.listenAppointments) {
                        this.setListenAppointments(true)

                        return false
                    }

                    var size = 0

                    snapshot.docChanges().forEach((change) => {
                        if (change.type == 'added') {
                            var appointment = change.doc.data()

                            var start = moment.duration(appointment.time * 15, 'minutes')
                            var end = start.clone().add(15, 'minutes')

                            appointment.start = moment.utc(start.asMilliseconds()).format(this.$t('time_format'))
                            appointment.end = moment.utc(end.asMilliseconds()).format(this.$t('time_format'))

                            var messageDate = moment(appointment.date, "YYYY-MM-DD").format(this.$t('appointment_notification_date_format'))
                            var messageTime = moment.utc(start.asMilliseconds()).format(this.$t('time_format'))

                            var message = this.$t('appointment_notification_content', {
                                firstName: this.hashPatientInfo(appointment.patientFirstName),
                                lastName: this.hashPatientInfo(appointment.patientLastName),
                                date: messageDate,
                                time: messageTime
                            })

                            this.addNotification({
                                type: 'is-info',
                                content: message,
                                active: true,
                                appointment: appointment
                            })
                        }

                        size++
                    })
                })
        },

        closeEmergencyModal() {
            this.showEmergencyModal = false
            this.currentAvailability = {}
            this.currentEmergency = {}
            document.documentElement.classList.toggle('is-clipped', false)
        },

        showEmergency(appointment) {
            this.setLoading(true)

            var emergencyId = appointment.emergencyId

            emergencyRepository.find(emergencyId, (emergency) => {
                this.currentAvailability = appointment
                this.currentEmergency = emergency
                this.showEmergencyModal = true

                this.setLoading(false)
            }, (error) => {
                this.alertError(error.message)

                this.setLoading(false)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Doctor/App.vue